import * as React from 'react';

import * as styles from './styles.css';
import { PriceItem } from '../PriceItem';

interface IPricesBlockProps {
  estimationPrice: React.ReactNode;
  estimationTooltip?: React.ReactNode | null;
  offerPrice?: React.ReactNode | null;
  offerTooltip?: React.ReactNode | null;
  estimationLabel: string;
  offerLabel: string;
}

export const PricesBlock: React.FC<IPricesBlockProps> = props => {
  const { estimationPrice, estimationTooltip, offerPrice, offerTooltip, offerLabel, estimationLabel } = props;

  return (
    <div className={styles['container']}>
      <div className={styles['item']}>
        <PriceItem
          testId="valuation_estimationPrice"
          price={estimationPrice}
          caption={estimationLabel}
          captionTooltip={estimationTooltip}
        />
      </div>
      {offerPrice && (
        <div className={styles['item']}>
          <PriceItem
            testId="valuation_offerPrice"
            price={offerPrice}
            caption={offerLabel}
            priceTooltip={offerTooltip}
          />
        </div>
      )}
    </div>
  );
};

PricesBlock.displayName = 'PricesBlock';
